/**
 * assets/bottom-nav-bar.js
 *
 * Handles interactions for the mobile bottom navigation bar.
 * - Finds existing theme toggles for Menu and Filters.
 * - Clicks them programmatically.
 */
(function () {
  // Find the button in our new nav bar that should open the main menu
  const menuToggle = document.querySelector('[data-bottom-nav-toggle-menu]');
  if (menuToggle) {
    // Find the theme's actual mobile menu button
    const themeMenuButton = document.querySelector('.mobile-nav-toggle, [aria-controls="main-nav"], [aria-controls="mobile-menu"]');
    if (themeMenuButton) {
      menuToggle.addEventListener('click', () => themeMenuButton.click());
    }
  }

  // Find the button in our new nav bar that should open the filters
  const filterToggle = document.querySelector('[data-bottom-nav-toggle-filters]');
  if (filterToggle) {
    // Find the theme's actual filter button (using the selector from our edu popup)
    const themeFilterButton = document.querySelector('[data-toggle-filters], #FilterToggleButton, .mobile-facets__open');
    if (themeFilterButton) {
      filterToggle.addEventListener('click', () => themeFilterButton.click());
    }
  }
})();